import { useState } from "react";

export const useForm = (initialState = {}) => {

    const [values, setValues] = useState(initialState);

    const reset = () => {
        setValues(initialState);
    }

    const handleInputChange = ({ target }) => {
        
        if (target.name === 'dates') {
            if (target.value?.length >0) {
                setValues({
                    ...values,
                    firstDate: target.value[0]?.getFullYear() + '-' + (target.value[0]?.getMonth() + 1) + '-' + target.value[0]?.getDate(),
                    lastDate: target.value[1]?.getFullYear() + '-' + (target.value[1]?.getMonth() + 1) + '-' + target.value[1]?.getDate()
                })
            } else {
                setValues({
                    ...values,
                    firstDate: '',
                    lastDate: ''
                })
            }

        } else if (target.name === 'remember') {
            setValues({
                ...values,
                remember : target.checked
            })

        }else {
            setValues({
                ...values,
                [target.name]: target.value
            })
        }
    };

    return [values, handleInputChange, reset]
}
